var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaneTakeOffBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plane-take-off 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 18H21V20H3V18ZM21.509 8.527C21.228 7.683 20.317 7.227 19.473 7.508L15 9L7 6L5 7L11 11L7 13L3 11L2 12L6 16L20.547 10.545C21.358 10.24 21.783 9.35 21.509 8.527Z",
    fill: "#1B1D52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneTakeOffBlue);
export default __webpack_public_path__ + "static/media/plane-take-off-blue.f25aa0b42eb0fa646064dd6ad4de493a.svg";
export { ForwardRef as ReactComponent };